<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.upgrades.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data">
          <div *ngFor="let message of messages">
            <span innerHtml="{{ message | translate : { value: plugin } }}"></span>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <table class="ir-plugin-table" *ngIf="plugin?.config?.Upgrades?.length && !loading; else empty">
      <tr class="th-plugin-line--subheader">
        <td style="width: 40%">
          <span>
            <strong>{{ 'plugins.upgrades.upgrade' | translate }}</strong>
          </span>
        </td>
        <td style="width: 20%">
          <span>
            <strong>{{ 'plugins.upgrades.benefit' | translate }}</strong>
          </span>
        </td>
        <td style="width: 20%">
          <span>
            <strong>{{ 'plugins.upgrades.status' | translate }}</strong>
          </span>
        </td>
        <td style="text-align: center; width: 20%">
          <span>
            <strong>{{ 'plugins.upgrades.recommended' | translate }}</strong>
          </span>
        </td>
        <td></td>
      </tr>
      <tr *ngFor="let upgrade of plugin?.config?.Upgrades">
        <td>
          <span>{{ upgrade.Name }}</span>
        </td>
        <td>
          <span>
            <ng-container *ngFor="let benefit of upgrade.Benefits; last as l">
              {{ 'plugins.upgrades.benefits.' + benefit | translate }}<ng-container *ngIf="!l">, </ng-container>
            </ng-container>
          </span>
        </td>
        <td>
          <span>{{ 'plugins.upgrades.statuses.' + upgrade.Status | translate }}</span>
        </td>
        <td style="text-align: center">
          <span><i style="color: #4c9c41" *ngIf="upgrade.Recommended" class="material-icons">done</i></span>
        </td>
        <td class="th-plugin-line--value">
          <span (click)="openDetails(upgrade)"><i style="cursor: pointer" class="material-icons">info_outline</i></span>
        </td>
      </tr>
    </table>
    <ng-template #empty>
      <div class="ir-plugin-values th-plugin-values">
        <p>
          <span *ngIf="loading">{{ 'common.loading' | translate }}...</span>
          <span *ngIf="!loading">{{ 'plugins.upgrades.no-equipment' | translate }}</span>
        </p>
      </div>
    </ng-template>
  </div>
</div>
